import type { NavigationState } from './types';

export const SET_NAV_STATE = 'SET_NAV_STATE';

const NavigationActions = {
  setNavState: (newState: Partial<NavigationState>) => ({
    type: SET_NAV_STATE,
    payload: newState,
  }),
};

export default NavigationActions;
